var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "198.425px",
    height: "198.426px",
    viewBox: "0 0 198.425 198.426",
    enableBackground: "new 0 0 198.425 198.426",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M198.425,99.213c0,54.792-44.418,99.214-99.214,99.214C44.416,198.427,0,154.005,0,99.213 C0,44.414,44.416-0.001,99.211-0.001C154.007-0.001,198.425,44.414,198.425,99.213z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.9434,
    y1: 21.6709,
    x2: 153.6994,
    y2: 176.9906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    style: {
      stopColor: "#2FB4E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4731,
    style: {
      stopColor: "#008FCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7645,
    style: {
      stopColor: "#005899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#004587"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M194.208,99.155c0,52.478-42.533,95.006-95.006,95.006c-44.604,0-82.008-30.73-92.227-72.176 c18.592-0.212,36.225-4.371,52.143-11.627V73.383c0-2.93-1.018-5.072-3.052-6.428c-2.029-1.348-5.638-2.028-10.831-2.028v-3.426 c6.883-0.229,13.195-0.637,18.931-1.212c5.744-0.578,10.691-1.447,14.853-2.604l0.087,53.703c0,3.044,0,6.368,0,9.974 c0,3.5-0.051,6.938-0.168,10.318c-0.115,3.386-0.286,6.54-0.509,9.47c-0.229,2.934-0.509,5.411-0.85,7.438 c5.646,3.276,11.909,5.979,18.797,8.125c6.887,2.143,13.318,3.208,19.301,3.208c5.08,0,9.992-0.761,14.731-2.283 c4.743-1.522,8.949-3.748,12.612-6.69c3.67-2.935,6.637-6.54,8.896-10.837c2.256-4.292,3.383-9.151,3.383-14.571 c0-4.965-0.848-9.54-2.542-13.719c-1.694-4.18-4.069-7.788-7.126-10.842c-3.052-3.054-6.662-5.446-10.845-7.197 c-4.187-1.755-8.762-2.631-13.736-2.631c-3.732,0-7.542,0.657-11.442,1.96c-3.906,1.313-7.435,2.935-10.598,4.861V81.987 c17.111-17.88,29.152-40.646,33.789-66.006C111.624,6.988,87.082,5.818,63.869,14.63c-25.786,9.786-44.645,29.877-53.677,53.806 c8.701-25.763,28.42-47.568,55.818-57.977c22.877-8.679,46.777-7.915,67.651,0.237c0.002-0.021,0.011-0.043,0.013-0.06 C169.095,24.437,194.208,58.855,194.208,99.155z M101.899,147.81c2.591,4.461,6.99,6.687,13.198,6.687 c6.194,0,10.6-2.226,13.197-6.687c2.594-4.452,3.89-11.474,3.89-21.066c0-9.584-1.296-16.607-3.89-21.063 c-2.597-4.457-7.002-6.68-13.197-6.68c-6.208,0-10.607,2.223-13.198,6.68c-2.595,4.455-3.891,11.479-3.891,21.063 C98.008,136.336,99.304,143.357,101.899,147.81z M77.145,47.01c2.635-2.569,3.949-5.785,3.949-9.65c0-3.863-1.314-7.08-3.949-9.652 c-2.625-2.576-5.817-3.864-9.558-3.864c-3.745,0-6.937,1.288-9.565,3.864c-2.632,2.572-3.945,5.789-3.945,9.652 c0,3.865,1.313,7.081,3.945,9.65c2.628,2.576,5.82,3.863,9.565,3.863C71.328,50.873,74.52,49.586,77.145,47.01z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIb);
export default __webpack_public_path__ + "static/media/ib.3408e4225ee1af78e870f6ae99f37e59.svg";
export { ForwardRef as ReactComponent };